module.exports = __webpack_public_path__ + "img/iphone.b8f8408f.jpeg";